import types from './types';

// TODO Get rid of thunk here
export const startRouteLoading = () => (dispatch) => {
    dispatch({
        type: types.START_ROUTE_LOADING
    });
};

// TODO Get rid of thunk here
export const endRouteLoading = (newPage) => (dispatch) => {
    // TODO Rewrite this checking as it is not reliable enough
    // TODO No need to spread the whole window.location object here
    // convert string with page name into object with details
    if (!newPage || typeof newPage === 'string') {
        newPage = {
            name: newPage,
            details: {
                location: typeof window !== 'undefined' ? { ...window.location } : {}
            }
        };
    }

    dispatch({
        type: types.END_ROUTE_LOADING,
        payload: newPage
    });
};

// TODO Get rid of thunk here
export const errorsOnRouteLoading = (errors) => (dispatch) => {
    dispatch({
        type: types.ERRORS_ON_ROUTE_LOADING,
        payload: errors
    });
};

// TODO Get rid of thunk here
export const renderNextRoutesOnClient = () => (dispatch) => {
    dispatch({
        type: types.RENDER_NEXT_ROUTES_ON_CLIENT
    });
};
